class EventEmitter {
    _Listeners = {};
    constructor() { }
    on(event, listener) {
        if (!event || !listener)
            return false;
        this._Listeners[event] = this._Listeners[event] || [];
        this._Listeners[event].push(listener);
        return true;
    }
    off(event, listener) {
        if (!event || !listener)
            return false;
        const eventIndex = this._Listeners[event].indexOf(listener);
        if (eventIndex === -1)
            return false;
        this._Listeners[event].splice(eventIndex, 1);
        return true;
    }
    emit(event, ...args) {
        this._Listeners[event]?.forEach?.(listener => listener(...args));
    }
}
export default EventEmitter;
